import { useState, useEffect } from 'react';
import { AlertTriangle, Info, Flame } from 'lucide-react';
import { api } from '@/lib/api';

const META = {
  critical: { icon: Flame, cls: 'bg-red-50 text-red-700 border-red-200' },
  warning: { icon: AlertTriangle, cls: 'bg-gold/10 text-gold-dark border-gold/30' },
  info: { icon: Info, cls: 'bg-forest/5 text-forest border-forest/20' },
};

export default function AdminAnalytics() {
  const [data, setData] = useState({ insights: [], capacity: [] });
  useEffect(() => { api.get('/admin/recruitment').then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-analytics">
      <p className="font-manrope text-dark/60 mb-6">Where supplier coverage is weak, so you can proactively recruit farms before demand outpaces supply.</p>
      {data.insights.length === 0 ? (
        <div className="bg-white rounded-2xl border border-forest/10 p-12 text-center font-manrope text-dark/50">No recruitment insights right now — coverage looks healthy.</div>
      ) : (
        <div className="space-y-3">
          {data.insights.map((ins, i) => {
            const m = META[ins.severity] || META.info;
            return (
              <div key={i} className={`flex items-start gap-3 rounded-xl border p-4 ${m.cls}`} data-testid={`insight-${i}`}>
                <m.icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <div><p className="font-manrope font-semibold text-sm">{ins.category}</p><p className="font-manrope text-sm opacity-90">{ins.message}</p></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
